import { createFileRoute, redirect } from "@tanstack/react-router";

import { authUserSchema } from "@/modules/auth/schemes";
import { ClosedByTechnicianTodayPage } from "@/modules/repairs/pages/ClosedByTechnicianToday.page";

export const Route = createFileRoute("/__authed/m/repairs/reports/closed-by-technician-today")({
	beforeLoad({ context }) {
		const parsedUser = authUserSchema.safeParse("user" in context ? context.user : undefined);

		if (!parsedUser.success || parsedUser.data.role.slug !== "admin") {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: ClosedByTechnicianTodayPage,
});
